import moment from '@/moment-gp.js'
import CommitmentTemplates from '@/components/Config/Wizard/CommitmentTemplates'
// import { mapGetters } from "vuex";

const challengeData = require('./challengedata');
const challengeOptions = challengeData.challengeOptions;
const challengeCustomFrequency = challengeData.challengeCustomFrequency;

var commitmentMixin = {
  computed: {
    user_get_dateformat() {
      return this.$models.userSettings.getters.user_get_dateformat;
    },
    challengeOptions() {
      return challengeOptions;
    },
    challengeCustomFrequency() {
      return challengeCustomFrequency;
    },
  },
  methods: {
    _getChallengeById( id ) {
      return {
        startDate: null, // TODO: get start date of challenge
        endDate: null
      };
    },
    commitmentText( effort, effort_meta ) {

      // TODO: Implement caching for this function
      // console.log("[mixin] commitmentText", effort.startDate, effort.endDate);

      let displayVariant = 2
      let effortInfo = ''

      // let startDate = moment.unix(effort.startDate / 1000).tz(this.user_get_timezone).format(this.user_get_dateformat)
      // let endDate = moment.unix(effort.endDate / 1000).tz(this.user_get_timezone).format(this.user_get_dateformat)

      let startDate = effort.startDate ? effort.startDate.format( this.user_get_dateformat ) : null;
      let endDate = effort.enDate ? effort.endDate.format( this.user_get_dateformat ) : null;

      if ( displayVariant === 1 ) {
        if ( effort.startDate && effort.endDate ) {
          effortInfo = " (first day: " + startDate + ", last day: " + endDate + ")";
        }
        if ( effort.startDate && !effort.endDate ) {
          effortInfo = " (first day: " + startDate + ")";
        }
        if ( !effort.startDate && effort.endDate ) {
          effortInfo = " (last day: " + endDate + ")";
        }
      } else if ( displayVariant === 2 ) {
        // let timeNow = moment.tz(this.user_get_timezone)
        // let effortNrDays = moment.unix(effort.endDate / 1000).diff(moment.unix(effort.startDate / 1000), 'days')
        // let effortNrDaysLeftUntilStart = moment.unix(effort.startDate / 1000).diff(timeNow, 'days')
        // let effortNrDaysLeftUntilEnd = moment.unix(effort.endDate / 1000).diff(timeNow, 'days')

        let timeNow = moment.currentTime(); // ... currentDate() ?
        if ( effort.endDate ) {
          let effortNrDaysLeftUntilEnd = effort.endDate.diff(timeNow, 'days')
          effortInfo = " (" + effortNrDaysLeftUntilEnd  + " days left until " + endDate +  ")";
        }
        if ( effort.startDate ) {
          let effortNrDaysLeftUntilStart = effort.startDate.diff(timeNow, 'days')
          if ( effortNrDaysLeftUntilStart > 0 ) {
            effortInfo = " (starts in " + effortNrDaysLeftUntilStart + " days)";
          }
        }
      }

      // TODO: Handle case where effort has no name name === ''
      if ( effort_meta.name === '' ) {
        return '* no name *'
      }

      return effort_meta.name + effortInfo;
    },

    commitmentStatusColorAndText( effort, effort_meta ) {
      let color, percentage, text;
      percentage = ''
      if (effort.startDate > moment.currentTime()) {
        color = "#777777"
      } else {
        if (effort.committedTimeDaily && effort.remainingTime && effort.committedTimeDaily > 0) {
          percentage = 100 - ( effort.remainingTime / ( effort.committedTimeDaily * 60 ) ) * 100;
          color =  this.statusColorCommitment(percentage)
        } else {
          color =  this.statusColorCommitment(0)
        }
      }
      if (percentage !== '') {
        text = percentage.toString() + "%"
      }
      return { color, text };
    },

    textCommitment( commitment ) {

      if ( !('commitmentOptionsSelected' in commitment) ||
        commitment.commitmentOptionsSelected.length === 0 ) {
        return commitment.name + ' (not configured)';
      }

      let optionIndices = new Array( commitment.commitmentOptionsSelected.length );

      let nestedVar = this.challengeOptions;
      for (var i = 0; i < commitment.commitmentOptionsSelected.length; i++) {
        optionIndices[i] = nestedVar.findIndex( el => {
          return el.value === commitment.commitmentOptionsSelected[i]
        });
        if (nestedVar[ optionIndices[i] ]) {
          nestedVar = nestedVar[ optionIndices[i] ].children;
        }
      }

      let optionIdx = optionIndices[0];
      let childIdxLvl1 = optionIndices[1];
      let childIdxLvl2 = optionIndices[2];
      let optionLvl1 = commitment.commitmentOptionsSelected[0];
      let optionLvl2 = commitment.commitmentOptionsSelected[1];
      let optionLvl3 = commitment.commitmentOptionsSelected[2];

      let label = '';
      if (this.challengeOptions[optionIdx] && this.challengeOptions[optionIdx].children[childIdxLvl1] && this.challengeOptions[optionIdx].children[childIdxLvl1].children[childIdxLvl2] ) {
        label = this.challengeOptions[optionIdx]
                        .children[childIdxLvl1]
                        .children[childIdxLvl2].label;
      } else {
        label = '';
      }

      let text;

     // || optionLvl2 === "totalSessions"
      //|| optionLvl2 === "recurringWeeks"
      if (optionLvl1 === "investTime") {
        if (optionLvl2 === "totalHours" ) {
          if (optionLvl3 === 'custom') {
            text = "Invest " +  commitment.customAmount + " hours in total";
          } else {
            text = "Invest " + label + " in total";
          }
        } else if (optionLvl2 === "periodicHours") {
          if (optionLvl3 === 'custom') {
            console.log( this.challengeCustomFrequency)
            text = "Invest " + commitment.customAmount + " hours " +  this.challengeCustomFrequency.find(item => item.value === commitment.customFrequency.toString()).label;
          } else {
            text = "Invest " + label;
          }
        }
      }

      if (optionLvl1 === "investMoney") {
        if (optionLvl2 === "total") {
          text = "Invest " + label + " in total";
        }
      }

      if (optionLvl1 === "saveMoney") {
        if (optionLvl2 === "total") {
          text = "Save " + label + " in total";
        }
      }

      if (optionLvl1 === "loseWeight") {
        if (optionLvl2 === "total") {
          text = "Lose " + label + " in total";
        }
      }

      let challengeStartDate;
      let challengeEndDate;
      if ( commitment.templateId ) {
        /* If this commitment was derrived from a challenge use the challenge
           start and end date, if not use the start and end date that was set
           by the user */
        let challenge = this._getChallengeById( commitment.templateId );
        // TODO: check if challenge exists
        challengeStartDate = challenge.startDate ? challenge.startDate.format( this.user_get_dateformat ) : null;
        challengeEndDate   = challenge.endDate   ? challenge.endDate.format( this.user_get_dateformat )   : null;
      } else {
        challengeStartDate = commitment.startDate ? commitment.startDate.format( this.user_get_dateformat ) : null;
        challengeEndDate   = commitment.endDate   ? commitment.endDate.format( this.user_get_dateformat )   : null;
      }

      if (challengeStartDate) {
        if (challengeEndDate) {
          text += " between " + challengeStartDate + " and " + challengeEndDate;
        } else {
          text += " from " + challengeStartDate;
        }
      } else if (challengeEndDate) {
        text += " until " + challengeEndDate;
      }
      return text;
    },

    textCommitmentTemplate(commitment) {
      if ( commitment.commitmentTemplateId !== null ) {
        let option = CommitmentTemplates.find(item => {
          return item.label === commitment.commitmentTemplateId
        });

        // console.log("[mixin] option>>", option);
        // TODO: use template
        return option ? 'Template: ' + option.text : 'Template not found';
      }
      return 'No template selected';
    },

    statusColorCommitment(finishedPercent) {
      let color = "#f28d00";
      if (finishedPercent === 100) {
        color = "#009f3c";
      } else if (finishedPercent === 0) {
        color = "#e30613";
      } else if (finishedPercent < 20) {
        color = "#ed6b06";
      } else if (finishedPercent < 40) {
        color = "#ed6b06";
      } else if (finishedPercent < 60) {
        color = "#f28d00";
      } else if (finishedPercent < 80) {
        color = "#8fbf21";
      } else if (finishedPercent < 100) {
        color = "#34a936";
      }
      return color;
    }
  }
};

export default commitmentMixin;
